import React, { Suspense } from 'react';
import { string } from 'prop-types';
import { Link } from 'react-router-dom';
import GreenButton from '../shared/GreenButton/GreenButton';
import BlueButton from '../shared/BlueButton/BlueButton';
import OpacityButton from '../shared/OpacityButton/OpacityButtonNormalLink';
//import DropDown from '../shared/DropDown/DropDown';
import BizImage from '../../assets/images/Bizdocs1.png';
import {
    Container,
    LinksContent,
    ButtonContent,
    //DropDownContent,
    HeaderContent,
    MarginBoxHeader,
    Anchor,
    Image,
    BurgerBox
} from './Header.style';
import BurgerMenu from '../BurgerMenu/BurgerMenu';
import Loader from '../../components/shared/Loader/Loader'
const Header = ({ bgColor }) => {
    return (
        <Suspense fallback={<Loader />}>
            <Container bgColor={bgColor}>
                <MarginBoxHeader>
                    <HeaderContent>
                        <a href="https://www.bizdocs.mobi/">
                            <Image imageSrc={BizImage} />
                        </a>

                        <ButtonContent>
                            <OpacityButton
                                content="Login"
                                width='88px'
                                maxWidth="500px"
                                margin="0 auto" minheight="55px"
                                to={window.location.protocol + "//" + window.location.hostname + ":" + (window.location.port == "62293" ? "5000" : "") + "/"}  />
                        </ButtonContent>
                    </HeaderContent>
                    <BurgerBox>
                        <BurgerMenu />
                    </BurgerBox>
                </MarginBoxHeader>
            </Container>
        </Suspense>
    );
};
Header.propTypes = {
    bgColor: string
};
Header.defaultProps = {
    bgColor: ''
};
export default Header;